import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MessageCircle, Send } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export const NewsletterPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preference: 'email'
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Inscrição realizada com sucesso! Você receberá nossas atualizações em breve.', {
      duration: 4000,
    });
    setFormData({ name: '', email: '', phone: '', preference: 'email' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="min-h-screen bg-dark-primary py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center text-purple-light hover:text-purple-primary transition-colors mb-8">
          <ArrowLeft className="mr-2" size={20} />
          Voltar para Home
        </Link>

        <div className="max-w-3xl mx-auto">
          <Card className="bg-dark-secondary border-green-primary/30 shadow-2xl">
            <CardHeader className="text-center">
              <CardTitle className="text-3xl sm:text-4xl font-bold font-archive text-white mb-3">
                Receba Nossas Atualizações
              </CardTitle>
              <CardDescription className="text-lg text-gray-400 font-hero">
                Fique por dentro de novos jogos, torneios e promoções exclusivas
              </CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="space-y-2">
                  <Label htmlFor="name" className="text-white font-hero">Nome Completo</Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Seu nome"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="bg-dark-primary border-purple-primary/30 text-white placeholder:text-gray-500 focus:border-green-primary"
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="email" className="text-white font-hero">E-mail</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="seu@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="bg-dark-primary border-purple-primary/30 text-white placeholder:text-gray-500 focus:border-green-primary"
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="phone" className="text-white font-hero">WhatsApp / Telegram (Opcional)</Label>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    placeholder="+55 (11) 99999-9999"
                    value={formData.phone}
                    onChange={handleChange}
                    className="bg-dark-primary border-purple-primary/30 text-white placeholder:text-gray-500 focus:border-green-primary"
                  />
                </div>

                <div className="space-y-3">
                  <Label className="text-white font-hero">Preferência de Contato</Label>
                  <div className="flex gap-4">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="preference"
                        value="email"
                        checked={formData.preference === 'email'}
                        onChange={handleChange}
                        className="w-4 h-4 text-green-primary focus:ring-green-primary"
                      />
                      <span className="text-gray-300 font-hero flex items-center gap-1">
                        <Mail size={16} /> E-mail
                      </span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="preference"
                        value="whatsapp"
                        checked={formData.preference === 'whatsapp'}
                        onChange={handleChange}
                        className="w-4 h-4 text-green-primary focus:ring-green-primary"
                      />
                      <span className="text-gray-300 font-hero flex items-center gap-1">
                        <MessageCircle size={16} /> WhatsApp
                      </span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="preference"
                        value="telegram"
                        checked={formData.preference === 'telegram'}
                        onChange={handleChange}
                        className="w-4 h-4 text-green-primary focus:ring-green-primary"
                      />
                      <span className="text-gray-300 font-hero flex items-center gap-1">
                        <Send size={16} /> Telegram
                      </span>
                    </label>
                  </div>
                </div>

                <Button 
                  type="submit" 
                  className="w-full bg-green-primary hover:bg-green-secondary text-white font-semibold py-6 text-lg rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-green-primary/50"
                >
                  Inscrever-se Agora
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
